import React, {lazy, Suspense} from 'react'

const BiblePageLazy = lazy(() =>
    import('./BiblePage')
)

const BiblePage = props => (
    <Suspense fallback={null}>
        <BiblePageLazy {...props} />
    </Suspense>
)

export default BiblePage
